import React from "react";
import { Box } from "../../../components";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { CustomerPortalCustomerInfo } from "../../../common/models";

interface Props {
  customer: CustomerPortalCustomerInfo;
}

const CustomerBasicInfoBox: React.FC<Props> = ({
  customer,
}): React.ReactElement => {
  const { tCustomer } = useCustomTranslation();

  return (
    <Box
      className="pt-4"
      cols={2}
      title={tCustomer("basic_info")}
      items={[
        {
          label: tCustomer("name"),
          value: customer.name,
        },
        {
          label: tCustomer("website"),
          value: customer.website,
          hidden: customer.kind === "Household",
        },
        {
          label: tCustomer("identification_number"),
          value: customer.identificationNumber,
          hidden: customer.kind === "Household",
        },
        {
          label: tCustomer("tax_number"),
          value: customer.taxNumber,
          hidden: customer.kind === "Household",
        },
        {
          label: tCustomer("owner"),
          value: customer.ownerName,
          hidden: true, // always hidden until we decide we need to show it
        },
      ]}
    />
  );
};

export default CustomerBasicInfoBox;
